import React from "react";
import "./Homespeciality.css";
// Replace with your actual image path
// import sampleImg from "/assets/timerectification.png";

const HeroSpeciality = () => {
  return (
    <section className="hero-speciality-homespeciality">
      {/* Left Content */}
      <div className="hero-content-homespeciality">
        <h4 className="hero-subtitle-homespeciality">SPECIALITY</h4>
        <h1 className="hero-title-homespeciality">
          DON’T KNOW YOUR<br />
        EXACT BIRTH  <br />
         TIME? ⏳<br />
         <br/>
          TIME <br />
          RECTIFICATION + <br />
          FULL KUNDLI <br/>ANALYSIS
        </h1>
        <p className="hero-text-homespeciality">
Even a few minutes’ difference can change your entire destiny.
We analyze your life events, nature, habits, and appearance to trace your exact birth time then decode your complete Kundli to reveal your real life path, purpose, and remedies aligned to it.
     </p>
        <a href="Time-Rectification"><button className="hero-btn-homespeciality"> Find My Exact Birth Time</button></a>
      </div>

      {/* Right Image */}
      <div className="hero-image-homespeciality">
        {/* <img src="/assets/timerectification.png" alt="Speciality Service" /> */}
        <img src="/assets/time rectification.png" alt="Speciality Service" />
      </div>
    </section>
  );
};

export default HeroSpeciality;
